import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const filesStartWOPIEditingSessionMutationAtom =
  createMutationAtomFactory(
    'office.startWOPIEditingSession',
    (params: { fileId: string; permission?: 'Read' | 'Write' }) => ({
      filesStartWOPIEditingSession: {
        __args: {
          input: {
            fileId: params.fileId,
            permission: params.permission || 'Write',
          },
        },
        session: {
          fileId: true,
          editUrl: true,
          collaboraUrl: true,
          token: {
            token: true,
            tokenId: true,
            expiresAt: true,
            permission: true,
            fileId: true,
            userId: true,
            userName: true,
            userEmail: true,
          },
        },
      },
    }),
  );
